import React, { useState } from 'react'
import moment from "moment";
let SERVER_URL = process.env.REACT_APP_API_URL;
let BASE_URL = process.env.REACT_APP_APP_URL;
function Att_StatusComp({ user_id, inOut_count, start_time, end_time, att_date, daysname, holiday_name, year, month,leave_status }) {
    // return inOut_count == 1 && <div>
    //     present-{user_id}-{inOut_count}
    // </div>

    // return inOut_count >= 1 && <div>
    //     present-{user_id}-{inOut_count}
    // </div>
    const [totalHRS, setTotalHRS] = useState(0)
    const gettoken = localStorage.getItem('key');
    // const token_data = jwt_decode(gettoken);
    const newToken = JSON.parse(gettoken);
    const token = newToken.value;
    // if (totalHRS==0  ) {
    //     return <div className="table_btn absent1">Present</div>
    // }
    // console.log('inOut_count===', inOut_count)
    // console.log('holiday_name===', holiday_name)
    // console.log('holiday_name day===', moment(new Date(year, month - 1, daysname)).format("ddd"))
    if (inOut_count == undefined && holiday_name == undefined && ((moment(new Date(year, month - 1, daysname)).format("ddd") !== 'Sun' && moment(new Date(year, month - 1, daysname)).format("ddd") !== 'Sat'))) {
        return <div className="table_btn absent1">Absent</div>

    }
    if(leave_status === 1 && moment(new Date(year, month - 1, daysname)).format("ddd") !== 'Sat' && moment(new Date(year, month - 1, daysname)).format("ddd") !== 'Sun'){
        return <div className="table_btn leave1">On Leave</div> 
    }
    if (inOut_count === 1) {
        var startTime = moment(start_time, 'hh:mm:ss a');
        var endTime = moment(end_time, 'hh:mm:ss a');
        var totalMinutes = endTime.diff(startTime, 'minutes');



        if ((moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sat')) {
            return true
        } else {
            if (totalMinutes < 240) {
                return <div className="table_btn absent1">Absent</div>
            }
            if (totalMinutes >= 240 && totalMinutes < 420) {
                return <div className="table_btn halfday1">Halfday</div>
            }
            if (totalMinutes >= 420) {
                return <div className="table_btn present1">Present</div>
            }
        }



    }
    if (inOut_count > 1) {
        let token = JSON.parse(localStorage.getItem('key'));
        const response = fetch(SERVER_URL + `api/attendance/day-in-out`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({ att_date: moment(att_date).format("YYYY-MM-DD"), user_id: user_id }),
            }).then(res => res.json())
            .then(data => {
                var tmp = 0;
                var total_hrs = 0;
                for (var i = 0; i < data?.data?.length; i++) {
                    const createdDate = moment(data?.data[i].att_date).format('YYYY-MM-DD');
                    const updatedDate = moment(data?.data[i].updated_on).format('YYYY-MM-DD');
                    const timeIn = data?.data[i].start_time
                    const timeOut = data?.data[i].end_time

                    var intime = new Date(createdDate + ' ' + timeIn);
                    var outtime = new Date(updatedDate + ' ' + timeOut);

                    var diffInSeconds = Math.abs(intime - outtime) / 1000;

                    var hours = Math.floor(diffInSeconds / 60 / 60 % 24);
                    var minutes = Math.floor(diffInSeconds / 60 % 60);
                    tmp = tmp + minutes
                    total_hrs = total_hrs + hours

                }
            

                var HRS = total_hrs + Math.floor(tmp / 60)
                var MNTS = tmp % 60
                setTotalHRS((HRS))
            })


        if ((moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sun' || moment(new Date(year, month - 1, daysname)).format("ddd") == 'Sat')) {
            return true
        } else {
            if (totalHRS < 4) {
                return <div className="table_btn absent1">Absent</div>
            }
            if (totalHRS >= 4 && totalHRS <= 6) {
                return <div className="table_btn halfday1">Halfday</div>
            }
            if (totalHRS >= 7) {
                return <div className="table_btn present1">Present</div>
            }
        }
    }
}

export default Att_StatusComp
